// F4 — Reports index page. Shows 14 report cards, each linking to its individual page.
// Visibility: all roles except customer (enforced server-side; frontend just shows what's accessible).

import React from "react";
import { useNavigate } from "react-router-dom";

const REPORTS = [
  // Pre-execution
  { path: "site_marking",        title: "1. Assigned to Site Marking",         desc: "Projects awaiting site marking, with civil team and ageing." },
  { path: "3d_discussion",       title: "2. 3D Discussion",                    desc: "Projects in 3D discussion stage, with design team and ageing." },
  { path: "quotation_discussion",title: "3. Quotation Discussion",             desc: "Projects in quotation stage, with sales team and ageing." },
  { path: "2d_material",         title: "4. 2D and Material Selection",        desc: "Projects with sales/design/civil teams and ageing." },
  { path: "handover_pending",    title: "5. Handover Pending",                 desc: "Projects pending handover, with sales/civil/design teams." },
  // Execution sub-stages (1-3)
  { path: "exec_cutlist_pending",       title: "6. Cutlist Pending (in execution)",            desc: "Projects under execution where cutlist task is open and overdue." },
  { path: "exec_cutlist_done_no_plan",  title: "7. Cutlist Done, Factory Plan Not Created",    desc: "Cutlist closed but no factory production plan yet." },
  { path: "exec_factory_production",    title: "8. Factory Plan Created, Production Not Done", desc: "Factory plan exists but production task is open." },
  { path: "exec_dispatch_pending",      title: "9. Production Done, Dispatch Pending",         desc: "Factory production closed but dispatch task is still open." },
  // Execution sub-stages (10-12)
  { path: "exec_carcass",         title: "10. Carcass Stage",            desc: "Projects in carcass completion. Civil engineer, net value, ageing." },
  { path: "exec_accessories",     title: "11. Accessories Fitting Stage",desc: "Projects in accessories fitting. Civil engineer, net value, ageing." },
  { path: "exec_final_fitting",   title: "12. Final Fitting Stage",      desc: "Projects in final fitting. Civil engineer, net value, ageing." },
  // F5 + Timeline
  { path: "project_breakdown",    title: "13. Project Stage Breakdown (F5)", desc: "Pick a project — see days spent in each stage with grand total." },
  { path: "timeline",             title: "14. Overall Project Timeline",     desc: "Filter by handover or final-fitting date range. Days from handover to final fitting." },
  // Site Masking
  { path: "site_masking_pending", title: "15. Site Masking Pending",         desc: "Projects where Site masking task has started and is not closed. Civil engineer, ageing." },
  { path: "plan_vs_actual",       title: "16. Plan vs Actual",              desc: "Every in-execution project: planned vs actual working days per stage, with total and days remaining." },
];

const Reports = () => {
  const navigate = useNavigate();

  return (
    <div className="container-fluid p-4">
      <div className="d-flex align-items-center mb-4">
        <h3 className="mb-0">Reports</h3>
      </div>

      <div className="row g-3">
        {REPORTS.map((r) => (
          <div className="col-12 col-md-6 col-xl-4" key={r.path}>
            <div
              className="card h-100 shadow-sm"
              role="button"
              onClick={() => navigate(`/reports/${r.path}`)}
              style={{ cursor: "pointer", borderLeft: "4px solid #2b6cb0" }}
            >
              <div className="card-body">
                <h5 className="card-title">{r.title}</h5>
                <p className="card-text text-muted small mb-0">{r.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reports;
